import clsx from 'clsx'
import React from 'react'

interface PlanCardGraySectionProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> {
  children: React.ReactNode;
  wideMode?: boolean;
}

export function PlanCardGraySection ({
  children,
  wideMode,
  ...props
}: PlanCardGraySectionProps) {
  return (
    <div
      {...props}
      className={clsx(
        'p-4 flex-shrink-0 flex-grow-0',
        'group-data-[layout="horizontal"]/plan-card:first:rounded-l-lg group-data-[layout="vertical"]/plan-card:first:rounded-t-lg group-data-[layout="horizontal"]/plan-card:last:rounded-r-lg group-data-[layout="vertical"]/plan-card:last:rounded-b-lg',
        'bg-gray-50',
        'group-data-[layout="horizontal"]/plan-card:only:w-full',
        wideMode
          ? 'group-data-[layout="horizontal"]/plan-card:w-64'
          : 'group-data-[layout="horizontal"]/plan-card:w-55'
      )}
    >
      {children}
    </div>
  )
}

PlanCardGraySection.displayName = 'PlanCard.GraySection'
